const module = { name: 'shared/seatMap/seatMap', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { swig as swig } from 'require-core';



import { Fandango as Fandango_context_freeTicketMovieIds_movieDetails_showtimeData } from 'require-core';

const { context: { featureFlags }, freeTicketMovieIds, movieDetails, showtimeData } = Fandango_context_freeTicketMovieIds_movieDetails_showtimeData;


import { Fandango_debugLog as debugLog } from 'require-core';



import { default as modal } from 'swug-fdRequire-call:Fandango/modal';



import { Fandango_xhr as xhr } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { default as Constants } from 'swug-fdRequire-call:shared/seatMap/constants';



const SeatTypes = Constants.SeatTypes


const StatusCodes = Constants.StatusCodes


const Styles = {
    API_FAIL: 'smp--fail',
    API_SUCCESS: 'smp--success',
    SEAT: 'smp__seat',
    SEAT_SELECTED: 'smp__seat--selected',
    SEAT_ACTIVE: 'smp__seat--active',
    SEATS_LINKED: 'smp__seat--linked',
    TOOLTIP: 'smp__tooltip',
    TOOLTIP_VISIBLE: 'smp__tooltip--visible',
    TOOLTIP_DISMISSED: 'smp__tooltip--dismissed',
}


const Classes = {
    SEATS_LINKED: 'js-smp-seats-linked',
    SEAT_STANDALONE: 'js-smp-seats-standalone',
    TOOLTIP_TARGET: 'js-hover-tooltip__target',
}


const Layout = {
    BACK_LABEL_GAP: 32,
}


const Selectors = {
    CONTENT: '#seat-map-preview-content',
    PREVIEW_BTN: '.js-seat-map-preview-btn',
    PREVIEW_MODAL: '#seat-map-preview-modal',
    RENDER_ELEMENT: '.js-smp-render',
    CHECK_SEATS: '#check-seats-btn'
}


const AriaLabels = {
    [SeatTypes.WHEELCHAIR]: ' - This is a wheelchair space and is not a seat',
    [SeatTypes.COMPANION]: ' - This is a wheelchair companion seat',
}


const SeatIcons = {
    [SeatTypes.WHEELCHAIR]: {
        available: '/images/shared/icons/global/icon-seat-wheelchair.svg',
        unavailable: '/images/shared/icons/global/icon-seat-wheelchair-unavailable.svg',
    },
    [SeatTypes.COMPANION]: {
        available: '/images/shared/icons/global/icon-seat-companion.svg',
        unavailable: '/images/shared/icons/global/icon-seat-companion-unavailable.svg',
    },
}
function parseSeatId(seatId) {
    const match = seatId.match(/^([A-Za-z]+)(\d+)$/);
    return match ? { row: match[1].toUpperCase(), seatNum: match[2] } : null;
}
function getAriaLabel(seatId, seatType) {
    const parsed = parseSeatId(seatId);
    const seatDesc = parsed ? `Row ${parsed.row} Seat ${parsed.seatNum}` : `Seat ${seatId}`;
    const typeSuffix = AriaLabels[seatType.toLowerCase()] || '';
    return `${seatDesc}${typeSuffix}`;
}
function setAriaAttributes(element, attributes) {
    Object.entries(attributes).forEach(([key, value]) => {
        element.setAttribute(key, value);
    });
}
function createTooltip(text, seatId) {
    const tooltip = document.createElement('span');
    const tooltipId = `seat-tooltip-${seatId}`;
    tooltip.className = Styles.TOOLTIP;
    tooltip.id = tooltipId;
    tooltip.textContent = text;
    tooltip.setAttribute('role', 'tooltip');
    tooltip.setAttribute('aria-hidden', 'true');
    return { tooltip, tooltipId };
}
function hideTooltip(tooltip) {
    if (tooltip) {
        tooltip.classList.add(Styles.TOOLTIP_DISMISSED);
        tooltip.setAttribute('aria-hidden', 'true');
    }
}
function resetTooltip(tooltip) {
    if (tooltip) {
        tooltip.classList.remove(Styles.TOOLTIP_DISMISSED);
    }
}
function attachTooltipListeners(seatElement) {
    const tooltip = seatElement.querySelector(`.${Styles.TOOLTIP}`);
    if (!tooltip) {
        return;
    }
    const handleKeydown = (event) => {
        if (event.key === 'Escape' || event.key === 'Esc') {
            hideTooltip(tooltip);
        }
    };
    const handleBlur = () => {
        resetTooltip(tooltip);
    };
    seatElement.addEventListener('keydown', handleKeydown);
    seatElement.addEventListener('blur', handleBlur);
}
function getSeatElement(seat, isInteractiveMap, seatsInBlock, cartSeatIdSet) {
    const { id, areaId, type, sellIndividuallyWithinSeatBlock: sellInBlock, width, height, x, y, } = seat;
    const seatId = id?.toUpperCase() ?? '';
    let { status } = seat;
    if (cartSeatIdSet?.has(seatId) && StatusCodes.UNAVAILABLE.includes(status)) {
        status = StatusCodes.AVAILABLE[0];
    }
    const isInteractiveSeat = isInteractiveMap && StatusCodes.AVAILABLE.includes(status);
    const isUnavailableSeat = StatusCodes.UNAVAILABLE.includes(status);
    const seatElement = document.createElement(isInteractiveSeat ? 'button' : 'div');
    const seatType = type || SeatTypes.STANDARD;
    const hoverText = `Seat ${seatId || ''}`;
    const linkedSeatIds = seatsInBlock && !sellInBlock
        ? seatsInBlock.filter(blockSeat => blockSeat.id !== id).map(blockSeat => blockSeat.id.toUpperCase())
        : null;
    seatElement.className = `
      ${Styles.SEAT}
      ${Styles.SEAT}--${status}
      ${Styles.SEAT}--${seatType}
      ${!seatsInBlock ? Classes.SEAT_STANDALONE : ''}
      ${isInteractiveSeat ? Styles.SEAT_ACTIVE : ''}
      ${Classes.TOOLTIP_TARGET}`;
    Object.assign(seatElement.dataset, {
        id: seatId,
        areaId,
        ...(linkedSeatIds && { linkedSeatIds }),
        w: width,
        h: height,
        y,
        x,
        hoverText,
        type: seatType,
    });
    if (isInteractiveMap) {
        const { tooltip, tooltipId } = createTooltip(hoverText, seatId);
        setAriaAttributes(seatElement, {
            role: 'checkbox',
            'aria-label': getAriaLabel(seatId, seatType),
            'aria-disabled': isUnavailableSeat,
            'aria-checked': false,
            'aria-describedby': tooltipId
        });
        seatElement.appendChild(tooltip);
        attachTooltipListeners(seatElement);
    }
    const seatIcons = SeatIcons[seatType];
    if (seatIcons) {
        const icon = document.createElement('img');
        icon.src = isUnavailableSeat ? seatIcons.unavailable : seatIcons.available;
        icon.alt = '';
        icon.setAttribute('aria-hidden', 'true');
        icon.className = 'smp__seat-icon';
        seatElement.appendChild(icon);
        if (!isInteractiveMap && seatId) {
            setAriaAttributes(seatElement, {
                role: 'img',
                'aria-label': getAriaLabel(seatId, seatType),
            });
        }
    }
    return seatElement;
}
function forceSvgViewBox(svgString, width, height) {
    if (!svgString || svgString.includes('viewBox')) {
        return svgString;
    }
    return svgString.replace('<svg', `<svg viewBox="0 0 ${width} ${height}"`);
}
function setBackground(renderElement, { backgroundSvg, backgroundWidth, backgroundHeight }) {
    if (!renderElement || !backgroundSvg) {
        return { labels: { screen: null, front: null, back: null } };
    }
    const svgWithViewBox = forceSvgViewBox(backgroundSvg, backgroundWidth, backgroundHeight);
    const { cleanedSvg, labels } = extractLabelsFromSvg(svgWithViewBox);
    const encodedBg = encodeURIComponent(cleanedSvg);
    renderElement.style.backgroundImage = `url("data:image/svg+xml;utf8,${encodedBg}")`;
    return { labels };
}
function extractLabelsFromSvg(svgString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgString, 'image/svg+xml');
    const svg = doc.querySelector('svg');
    const labels = { screen: null, front: null, back: null };
    if (!svg) {
        return { cleanedSvg: svgString, labels };
    }
    const topLevelGroups = svg.querySelectorAll(':scope > g');
    let theatreGroupIndex = 0;
    topLevelGroups.forEach((group) => {
        const enableBg = group.getAttribute('enable-background');
        if (enableBg) {
            if (theatreGroupIndex === 0) {
                labels.front = createMapLabel('Front of Theater', 'smp__label--theater smp__label--front');
            }
            else {
                labels.back = createMapLabel('Back of Theater', 'smp__label--theater smp__label--back');
            }
            theatreGroupIndex++;
            group.remove();
        }
        else {
            const nestedGroups = group.querySelectorAll(':scope > g');
            nestedGroups.forEach((nested) => {
                const paths = nested.querySelectorAll('path');
                const allWhite = paths.length > 0 && Array.from(paths).every(p => (p.getAttribute('fill') || '').toUpperCase() === '#FFFFFF');
                if (allWhite) {
                    labels.screen = createMapLabel('Screen', 'smp__label--screen');
                    nested.remove();
                }
            });
        }
    });
    const serializer = new XMLSerializer();
    const cleanedSvg = serializer.serializeToString(svg);
    return { cleanedSvg, labels };
}
function createMapLabel(text, className) {
    const label = document.createElement('span');
    label.textContent = text;
    label.className = `smp__label ${className}`;
    label.setAttribute('aria-hidden', 'false');
    return label;
}
function getMapCoordinates({ backgroundWidth, backgroundHeight, mapOffsetX, mapOffsetY, }) {
    return {
        mapWidth: Number(backgroundWidth),
        mapHeight: Number(backgroundHeight),
        offsetX: Number(mapOffsetX) || 0,
        offsetY: Number(mapOffsetY) || 0,
    };
}
function setSeatCoordinates({ element, scale, offsetX, offsetY }) {
    const x = Number(element.dataset.x);
    const y = Number(element.dataset.y);
    const w = Number(element.dataset.w);
    const h = Number(element.dataset.h);
    Object.assign(element.style, {
        left: ((offsetX + x) * scale) + 'px',
        top: ((offsetY + y) * scale) + 'px',
        width: (w * scale) + 'px',
        height: (h * scale) + 'px',
    });
}
function getMapDimensions({ mapWidth, mapHeight, offsetX, offsetY }, { totalWidth, totalHeight, seats }) {
    const hasBgDimensions = Number.isFinite(mapWidth) && Number.isFinite(mapHeight);
    const hasTotalDimensions = Number.isFinite(totalWidth) && Number.isFinite(totalHeight);
    let dimensions = { mapWidth, mapHeight, offsetX, offsetY };
    if (!hasBgDimensions) {
        if (hasTotalDimensions) {
            dimensions = {
                mapWidth: totalWidth,
                mapHeight: totalHeight
            };
        }
        else {
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            for (const seat of seats || []) {
                const x2 = seat.x + seat.width;
                const y2 = seat.y + seat.height;
                if (seat.x < minX) {
                    minX = seat.x;
                }
                if (seat.y < minY) {
                    minY = seat.y;
                }
                if (x2 > maxX) {
                    maxX = x2;
                }
                if (y2 > maxY) {
                    maxY = y2;
                }
            }
            if (!isFinite(minX)) {
                minX = 0;
                minY = 0;
                maxX = 1;
                maxY = 1;
            }
            dimensions = {
                mapWidth: Math.max(1, maxX - minX),
                mapHeight: Math.max(1, maxY - minY),
                offsetX: offsetX - minX,
                offsetY: offsetY - minY
            };
        }
    }
    return dimensions;
}
function getElementRow(element) {
    const seatId = element.dataset.id || element.querySelector('[data-id]')?.dataset.id;
    if (seatId) {
        const parsed = parseSeatId(seatId);
        if (parsed) {
            return parsed.row;
        }
    }
    return null;
}
function groupIntoRows(sortedElements) {
    const rowMap = new Map();
    let fallbackKey = null;
    let fallbackStartY = null;
    const Y_TOLERANCE = 20;
    sortedElements.forEach((item) => {
        const row = getElementRow(item.element);
        if (row !== null) {
            if (!rowMap.has(row)) {
                rowMap.set(row, []);
            }
            rowMap.get(row).push(item);
        }
        else {
            if (fallbackStartY === null || Math.abs(item.y - fallbackStartY) > Y_TOLERANCE) {
                fallbackKey = item.y;
                fallbackStartY = item.y;
                rowMap.set(`_y${fallbackKey}`, []);
            }
            rowMap.get(`_y${fallbackKey}`).push(item);
        }
    });
    return Array.from(rowMap.values());
}
function addSeats(renderElement, { seatBlocks = [], seats = [] }, isInteractiveMap, cartSeatIdSet) {
    const blockTypeById = {};
    const seatsByBlock = {};
    const standaloneSeats = [];
    const allElements = [];
    seatBlocks.forEach((seatBlock) => {
        if (seatBlock?.id) {
            const blockId = seatBlock.id.toString();
            blockTypeById[blockId] = seatBlock.type;
        }
    });
    seats.forEach((seat) => {
        if (seat.seatBlockId) {
            const id = seat.seatBlockId.toString();
            seatsByBlock[id] = seatsByBlock[id] || [];
            seatsByBlock[id].push(seat);
        }
        else {
            standaloneSeats.push(seat);
        }
    });
    Object.keys(seatsByBlock).forEach((blockId) => {
        const seats = seatsByBlock[blockId];
        const type = blockTypeById[blockId];
        if (type === SeatTypes.TWO_SEATER && seats.length === 2) {
            const [a, b] = seats;
            const minX = Math.min(a.x, b.x);
            const minY = Math.min(a.y, b.y);
            const maxX = Math.max(a.x + a.width, b.x + b.width);
            const maxY = Math.max(a.y + a.height, b.y + b.height);
            const wrapperElement = document.createElement('div');
            wrapperElement.className = `${Classes.SEATS_LINKED} ${Styles.SEATS_LINKED}`;
            Object.assign(wrapperElement.dataset, {
                x: minX,
                y: minY,
                w: maxX - minX,
                h: maxY - minY,
                blockId
            });
            seats.forEach((seat) => {
                const seatElement = getSeatElement(seat, isInteractiveMap, seats, cartSeatIdSet);
                wrapperElement.appendChild(seatElement);
            });
            allElements.push({ element: wrapperElement, x: minX, y: minY });
        }
    });
    standaloneSeats.forEach((seat) => {
        const seatElement = getSeatElement(seat, isInteractiveMap, null, cartSeatIdSet);
        allElements.push({ element: seatElement, x: seat.x, y: seat.y });
    });
    allElements.sort((a, b) => a.y - b.y || a.x - b.x);
    const seatsContainer = document.createElement('div');
    seatsContainer.className = 'smp__seats-container';
    if (isInteractiveMap) {
        seatsContainer.setAttribute('role', 'grid');
        groupIntoRows(allElements).forEach((rowItems) => {
            const rowEl = document.createElement('div');
            rowEl.setAttribute('role', 'row');
            rowEl.style.display = 'contents';
            rowItems.forEach(({ element }) => {
                const cell = document.createElement('div');
                cell.setAttribute('role', 'gridcell');
                cell.style.display = 'contents';
                cell.appendChild(element);
                rowEl.appendChild(cell);
            });
            seatsContainer.appendChild(rowEl);
        });
    }
    else {
        const mapFragment = document.createDocumentFragment();
        allElements.forEach(({ element }) => mapFragment.appendChild(element));
        seatsContainer.appendChild(mapFragment);
    }
    renderElement.appendChild(seatsContainer);
}
function layoutMap({ container, renderElement, mapWidth, mapHeight, offsetX = 0, offsetY = 0 }) {
    const availableWidth = container.clientWidth;
    const availableHeight = container.clientHeight;
    const scale = Math.max(0.0001, Math.min(availableWidth / mapWidth, availableHeight / mapHeight));
    renderElement.style.width = mapWidth * scale + 'px';
    renderElement.style.height = mapHeight * scale + 'px';
    renderElement.querySelectorAll(`.${Classes.SEAT_STANDALONE}`).forEach(element => setSeatCoordinates({ element, scale, offsetX, offsetY }));
    renderElement.querySelectorAll(`.${Classes.SEATS_LINKED}`).forEach(element => setSeatCoordinates({ element, scale, offsetX, offsetY }));
    const seatsContainer = renderElement.querySelector('.smp__seats-container');
    const backLabel = renderElement.querySelector('.smp__label--back');
    if (backLabel && seatsContainer) {
        let maxBottom = 0;
        seatsContainer.querySelectorAll(`.${Classes.SEAT_STANDALONE}, .${Classes.SEATS_LINKED}`).forEach((child) => {
            const top = parseFloat(child.style.top);
            const height = parseFloat(child.style.height);
            if (!isNaN(top) && !isNaN(height)) {
                maxBottom = Math.max(maxBottom, top + height);
            }
        });
        backLabel.style.top = (maxBottom + Layout.BACK_LABEL_GAP) + 'px';
    }
}
function onFail(err, container) {
    debugLog.warn(module.name, 'API err', err);
    container.classList.add(Styles.API_FAIL);
}
function render({ cartSeatIds, container, seatMapData, isInteractiveMap, showtimeData, renderElement }) {
    const hasSeatMapData = seatMapData && Object.keys(seatMapData).length > 0;
    if (!container || !hasSeatMapData || seatMapData.error) {
        return onFail((seatMapData?.error ?? 'render did not have map data'), container);
    }
    else if (!showtimeData || showtimeData.error) {
        return onFail((showtimeData.error ?? 'render has showtime error'), container);
    }
    const coordinates = getMapCoordinates(seatMapData);
    const { mapWidth, mapHeight, offsetX, offsetY } = getMapDimensions(coordinates, seatMapData);
    if (seatMapData?.maxTicketLimit) {
        renderElement.dataset.maxTicketLimit = seatMapData.maxTicketLimit;
    }
    const cartSeatIdSet = new Set((cartSeatIds || []).map(id => id.toUpperCase()));
    const createMap = () => layoutMap({
        container,
        mapHeight,
        mapWidth,
        offsetX,
        offsetY,
        renderElement,
    });
    const responsiveMap = new ResizeObserver(createMap);
    const { labels } = setBackground(renderElement, seatMapData);
    if (labels.screen) {
        renderElement.appendChild(labels.screen);
    }
    if (labels.front) {
        renderElement.appendChild(labels.front);
    }
    addSeats(renderElement, seatMapData, isInteractiveMap, cartSeatIdSet);
    if (labels.back) {
        renderElement.appendChild(labels.back);
    }
    createMap();
    responsiveMap.observe(container);
    container.classList.add(Styles.API_SUCCESS);
}
function addSeatMapData(variants) {
    return featureFlags.seatMapPreviewEnabled ? (variants || []).map(variant => ({
        ...variant,
        amenityGroups: (variant.amenityGroups || []).map((group) => {
            const allShowtimes = (group.showtimes || [])
                .filter(showtime => showtime?.type === 'available' && !showtime?.expired)
                .map(showtime => ({
                showtime: showtime.date,
                showtimeHashCode: showtime.showtimeHashCode,
                link: showtime.seatMapURL,
            }));
            return { ...group, allShowtimes: allShowtimes.length !== 0 ? JSON.stringify(allShowtimes) : null };
        }),
    })) : variants;
}
function fetchMapData(showtimes) {
    showtimes.forEach(({ showtimeHashCode }, index) => {
        const container = document.getElementById(`smp-map-${showtimeHashCode || index}`);
        if (showtimeHashCode) {
            const url = links.napiSeatMapByShowtime({
                showtimeHashCode,
            });
            xhr
                .ajax({
                url,
                method: 'GET',
            })
                .done(seatMapData => render({ container, seatMapData, isInteractiveMap: false, showtimeData, renderElement: container.querySelector(Selectors.RENDER_ELEMENT) }))
                .fail(err => onFail(err, container));
        }
        else {
            onFail('no showtimeHashCode', container);
        }
    });
}
function triggerAnalyticsEvent(dataSet) {
    const event = {
        event: 'seatmapPreview',
        dateSelected: dataSet.showtimeDate,
        formatSelected: dataSet.showtimeFormat,
        movieGenre: dataSet.movieGenre,
        movieID: dataSet.movieId,
        movieName: dataSet.movieTitle,
        theaterID: dataSet.theaterId,
        theaterName: dataSet.theaterName,
    };
    window.dataLayer && window.dataLayer.push(event);
}
function onPreviewClick() {
    const { movieId, moviePoster, movieTitle, showtimeFormat, showtimes: showtimeData, theaterName, } = this.dataset;
    triggerAnalyticsEvent(this.dataset);
    const showtimes = JSON.parse(showtimeData);
    const markup = swig.render('_seatMapPreview', {
        backgroundImg: movieDetails?.backgroundImg || moviePoster || '',
        btnText: freeTicketMovieIds?.split(',').map(id => id.trim()).includes(movieId) ? 'Select Seats' : 'Buy Tickets',
        movieTitle,
        showtimeFormat,
        showtimes,
        theaterName,
    });
    $(Selectors.CONTENT).html(markup);
    const modalDialog = document.querySelector(Selectors.CHECK_SEATS);
    if (modalDialog) {
        const ariaLabel = movieTitle && theaterName
            ? `Check seats for ${movieTitle} at ${theaterName}`
            : 'Check Seats';
        modalDialog.setAttribute('aria-label', ariaLabel);
    }
    fetchMapData(showtimes);
}
function renderModal() {
    modal.init(Selectors.PREVIEW_BTN, Selectors.PREVIEW_MODAL);
    $(Selectors.PREVIEW_BTN).off('click', onPreviewClick).on('click', onPreviewClick);
}
module.exports = {
    addSeatMapData,
    onFail,
    render,
    renderModal,
    getAriaLabel,
    setAriaAttributes,
};
export default module.exports;